module.exports = __webpack_public_path__ + "static/media/FWI_1.0823d860.jpg";